/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getDoctorList = (params) => makeApiCall(`/doctors/list`, 'GET', params);

export const getDoctorInfo = (params) => makeApiCall(`/doctor/get`, 'GET', params);

export const getDoctorChildInfo = (params) => makeApiCall(`/doctor/child/get`, 'GET', params);

export const getDoctorEnagagementHistory = (params) =>
  makeApiCall(`/doctor/touch-point/list`, 'GET', params);

export const getDoctorEnagagementHistoryDetail = (params) =>
  makeApiCall(`/doctor/touch-point/details`, 'GET', params);

export const getMdUsage = (params) => makeApiCall(`/doctors/product/top`, 'GET', params);

// MD Profile Module //
export const getMdMasterlist = (params) => makeApiCall(`/doctor/master-list`, 'GET', params);

export const getMdSalesInfo = (params) => makeApiCall(`/doctors/sales-info`, 'GET', params);

export const getMdAccountManagement = (params) => makeApiCall(`/account-management`, 'GET', params);

export const getMdAccountManagementDetails = (params) =>
  makeApiCall(`/account-management/details`, 'GET', params);

export const getMdCoverageDetails = (params) =>
  makeApiCall(`/account-management/coverage-details`, 'GET', params);

export const getMdRyg = (params) => makeApiCall(`/account-management/ryg`, 'GET', params);

export const getMdTicketsCount = (params) =>
  makeApiCall(`/account-management/md-tickets-count`, 'GET', params);

export const getMdTickets = (params) =>
  makeApiCall(`/account-management/md-tickets`, 'GET', params);

export const getMdTicketExport = (params) =>
  makeApiCall(`/account-management/md-tickets-export`, 'GET', params);
